module.exports = __webpack_public_path__ + "static/media/new_logo2.00a37013.png";